import { create } from 'zustand';
import type { UserDto } from '@/types/dtos/user/response/user.dto';

interface UserState {
  user?: UserDto;
  setUser: (change: UserDto) => void;
}

export const useUserStore = create<UserState>()((set) => ({
  user: undefined,
  setUser: (change) => set(() => ({ user: change })),
}));
